import { __assign } from 'tslib';
export function initializeApi(target, events) {
    return {
        on: events.on,
        off: events.off,
        emit: events.emit,
        meta: Object.assign({}, target),
    };
}
export function mergeApis(api, extenders, target) {
    const frags = extenders.map((extender) => extender(api, target));
    __assign(api, ...frags);
    return api;
}
//# sourceMappingURL=api.js.map